function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 15C9.18658 15 6.61031 13.8726 4.67419 12C6.02625 10.6923 7.6905 9.74799 9.52969 9.29728C9.19564 9.78101 9 10.3677 9 11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11C15 10.3677 14.8044 9.78101 14.4703 9.29728C16.3095 9.74799 17.9737 10.6923 19.3258 12C17.3897 13.8726 14.8134 15 12 15ZM12 7C16.0452 7 19.6525 8.9518 22 12C19.6525 15.0482 16.0452 17 12 17C7.95479 17 4.34753 15.0482 2 12C4.34753 8.95179 7.95479 7 12 7Z",
  fill: "#220C4A"
});

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.be0ac497.svg";
export { ForwardRef as ReactComponent };